import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filteredDataLength'
})
export class FilteredDataLengthPipe implements PipeTransform {

/*   getFilteredDataLength() {
    console.count('getFilteredDataLength');
    if (this.dataSourceMessages && this.dataSourceMessages.filteredData) {
        return this.dataSourceMessages.filteredData.length;
    } else {
      return 0;
    }
  } */

  transform(value: Array<any>): number {
    return value ? value.length : 0;
  }

}
